import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomSelect } from '../../../../commons/CustomSelect';
import { getMonthName } from '../../../../../utils';
import { useDateFsnLocale } from '../../../../../hooks/useDateFsnLocale';
import { useAppSelector } from '../../../../../hooks/redux';
import { monthNumbers } from '../../../../../constants/configuration';

interface MonthOptions {
  id: string;
  label: string;
}

interface MonthSelectProps {
  disabled: boolean;
  monthsOptions: string;
  handleMonthSelect: (value: string) => void;
}

const SessionsMonthSelector: FC<MonthSelectProps> = ({ disabled, monthsOptions, handleMonthSelect }) => {
  const { t } = useTranslation();
  const { selectedLanguage } = useAppSelector((state) => state.langReducer);
  const { fnsLocale } = useDateFsnLocale(selectedLanguage);

  const getMonthsOptions = (defaultMonthOptions: { value: number; label: string }[]): MonthOptions[] => {
    const convertedMonthsOptions: MonthOptions[] = [];
    defaultMonthOptions.map((el) =>
      convertedMonthsOptions.push({
        id: `${el.value}`,
        label: getMonthName(+el.label, fnsLocale),
      }),
    );
    return [{ id: 'for all months', label: t('serviceManagement.forAllMonths') }].concat(convertedMonthsOptions);
  };

  return (
    <div className="month-selector">
      <CustomSelect
        disabled={disabled}
        value={monthsOptions}
        setValue={(e) => handleMonthSelect(`${e.target.value}`)}
        items={getMonthsOptions(monthNumbers)}
      />
    </div>
  );
};

export default SessionsMonthSelector;
